export default () => {
    return 'be-fr';
};
